/**
 * Whether the player has been through the induction.
 *
 * One flag, in its own module, because two very different things need it and
 * neither should own it: the game store reads it once at startup to decide
 * which board to open on, and the overlay writes it when the induction is
 * finished or skipped. Same guarded-localStorage discipline as the run save —
 * an unreadable flag means "not done", which costs a returning player one
 * dismissal and costs a new one nothing.
 */

const TUTORIAL_KEY = "reagent.tutorial.v1";

export function isTutorialDone(): boolean {
  try {
    return window.localStorage.getItem(TUTORIAL_KEY) === "done";
  } catch {
    return false;
  }
}

export function markTutorialDone(): void {
  try {
    window.localStorage.setItem(TUTORIAL_KEY, "done");
  } catch {
    // The induction simply offers itself again next time.
  }
}
